import {Component, EventEmitter, Inject, Input, Output} from '@angular/core';
import {Category} from '@spartacus/core';
import {CategoryService} from '../../../../services/category.service';
import {DOCUMENT} from '@angular/common';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'dcp-category-entry',
  templateUrl: './category-entry.component.html',
  styleUrls: ['./category-entry.component.scss']
})
export class CategoryEntryComponent {
  @Input() category: Category;
  @Input() modal: NgbActiveModal;
  @Output() showSubCategoriesEvent = new EventEmitter<Category>();

  constructor(@Inject(DOCUMENT) public document: Document,
              public categoryService: CategoryService
  ) {
  }

  /**
   * If category has subCategories, method will emit showSubCategoriesEvent.
   * Emits emitSearchEvent otherwise.
   *
   * @param category current category
   */
  emitEvent(category: Category): void {
    if (category.subCategories) {
      this.showSubCategoriesEvent.emit(category);
    } else {
      const categoryId = category.code ? category.code : category.translationKey;
      this.categoryService.displayProductsOfCategory(categoryId);
      this.modal.dismiss('Browse menu is closed');
    }
  }
}
